(function() {
'use strict';

    angular
        .module('iMatApp')
        .factory('upload3DModelTrackEventsService', upload3DModelTrackEventsService);

    upload3DModelTrackEventsService.$inject = ['googleTagManagerService'];
    function upload3DModelTrackEventsService(googleTagManagerService) {
        var service = {
            trackFileSelected: trackFileSelected,
            trackFileDropped: trackFileDropped,
            trackRecentModelMenuOpened: trackRecentModelMenuOpened,
            trackRecentModelSelected: trackRecentModelSelected,
            trackViewerToggleAutoRotate: trackViewerToggleAutoRotate,
            trackAcceptDeclineV3RepairResults: trackAcceptDeclineV3RepairResults
        };
        
        return service;

        // ------------------------------------------------------------------------------

        function trackFileSelected() {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Funnel] Upload New Model',
                'eventAction': 'Single Upload Page',
                'eventLabel': undefined,
                'eventValue': undefined
            });

        }

        function trackFileDropped() {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Use Upload Control',
                'eventAction': 'Single Upload Page - Drag and Drop',
                'eventLabel': undefined, 
                'eventValue': undefined
            });
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Funnel] Upload New Model',
                'eventAction': 'Single Upload Page',
                'eventLabel': undefined,
                'eventValue': undefined
            });
        }
        
        function trackRecentModelMenuOpened() {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Use Upload Control',
                'eventAction': 'Single Upload Page - Select Recent Model in Viewer Menu',
                'eventLabel': undefined,
                'eventValue': undefined
            });
        }

        function trackRecentModelSelected() {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Funnel] Add Uploaded Model',
                'eventAction': 'Single Upload Page',
                'eventLabel': undefined,
                'eventValue': undefined
            });
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Use Upload Control',
                'eventAction': 'Single Upload Page - Add Recent Model from Viewer Menu',
                'eventLabel': undefined,
                'eventValue': undefined
            });
        }

        function trackViewerToggleAutoRotate(autoRotateEnabled) {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Change Viewer Control State',
                'eventAction': 'Single Upload Page - Auto-rotate by Viewer Double Click',
                'eventLabel': autoRotateEnabled ? 'Selected status: On' : 'Selected status: Off',
                'eventValue': undefined
            });
        }

        function trackAcceptDeclineV3RepairResults(isAccepted) {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Aggressive repair results',
                'eventAction': 'Single Upload Page',
                'eventLabel': isAccepted ? 'Accepted' : 'Declined',
                'eventValue': undefined
            });
        }
    }
})();